/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import Button from './Button';
import TextArea from './form/TextArea';
import FormResult from '../../FormResult';
import FormFeedback from './form/FormFeedback';
import './feedbackForm.css';

import { createNewFeedback } from '../../redux/ducks/feedback';

const yup = require('yup');

class FeedbackForm extends React.Component {
  // state = {
  // isSubmitting: false,
  // };

  render() {
    const { pageName, closeDialog } = this.props;

    const handleClose = () => {
      closeDialog();
    };

    return (
      <div>
        <Formik
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = () => {
              setSubmitting(false);
              closeDialog();
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            const value = {
              pageName,
              feedback: values.feedback,
            };

            this.props.onSubmit(value, onSuccess, onFailure);
          }}
          validationSchema={yup.object().shape({
            feedback: yup
              .string()
              .trim()
              .required('Please enter feedback'),
          })}
          render={({ handleSubmit, isSubmitting, status }) => (
            <Form>
              <div className="">
                <FormFeedback status={status} />
                <Field
                  name="feedback"
                  placeholder="Please enter any feedback for the current page or the website as a whole"
                  label="Enter Feedback:"
                  required
                  component={TextArea}
                />
                <div className="columns">
                  <Button
                    type="submit"
                    isActive={isSubmitting}
                    isDisabled={isSubmitting}
                    label="Send Feedback"
                    handler={handleSubmit}
                  />
                  <Button handler={handleClose} label="Close" />
                </div>
              </div>
            </Form>
          )}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (item, onSuccess, onFailure) => {
      dispatch(createNewFeedback(item, onSuccess, onFailure));
    },
  };
}

FeedbackForm.propTypes = {
  pageName: PropTypes.string.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default connect(undefined, mapDispatchToProps)(FeedbackForm);



// WEBPACK FOOTER //
// ./src/components/common/FeedbackForm.jsx